import AiChatAvatarStatic from "components/AiChat/Avatar/Static";
import Box from "ds/components/Box";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

const AssistantPanelChatWelcome = () => {
  return (
    <Box
      direction="column"
      justify="between"
      grow="1"
      zeroMinHeight
      fullWidth
      padding="xx-large x-large x-large"
    >
      <Box
        direction="column"
        align="center"
        justify="center"
        grow="1"
        className={styles.topSection}
      >
        <Box direction="column" gap="x-large" fullWidth>
          <Box direction="column" gap="medium">
            <Box direction="row" gap="medium" align="center" justify="center">
              <AiChatAvatarStatic size="large" />
              <Typography tag="p" variant="p-t5">
                Hi, how can I help you?
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AssistantPanelChatWelcome;
